import React from "react";
interface Metric {
    description: string;
    PCTL: number;
    bank: number;
    peer: number;
}
interface Metrics {
    Capital: Metric;
    "Asset quality": Metric;
    Management: Metric;
    Earnings: Metric;
    Liquidity: Metric;
}
interface DataType {
    bank_name: string;
    metrics: Metrics;
}
export const PercentileChart: React.FC<{ data?: DataType }> = ({ data }) => {
    if (!data || !data.metrics) {
        return <></>;
    }
    const bankName = data.bank_name;
    return (
        <>
            <div className="metrics-container-box">
                <div className="metrics-container">
                    {Object.entries(data.metrics).map(([metricKey, metric]) => (
                        <div
                            key={metricKey}
                            className={
                                metric.PCTL >= 70 ? "skyblue-matric-box" : "metric-box"
                            }
                        >
                            <div className="titlemetric">
                                <div className="metric-title">{metricKey}</div>
                                <div className="metric-subtitle">{metric.description}</div>
                            </div>
                            <div
                                className={
                                    metric.PCTL < 51
                                        ? "red-text-percentile"
                                        : metric.PCTL >= 51 && metric.PCTL <= 70
                                            ? "skyblue-text-percentile"
                                            : "metric-percentile"
                                }
                            >
                                {metric.PCTL} <div className="pctl-heading">PCTL</div>
                            </div>

                            <div className="barBoxGraph-section">
                                <div
                                    className="bank-box"
                                    style={{
                                        height: metric.bank > metric.peer ? "70px" : "60px",
                                    }}
                                >
                                    <span className="bar-value">
                                        {metric.bank.toString().replace(/^(\d+\.\d{2}).*$/, "$1")}%
                                    </span>
                                </div>
                                <div
                                    className="peer-box"
                                    style={{
                                        height: metric.peer > metric.bank ? "70px" : "60px",
                                    }}
                                >
                                    <span className="bar-value">
                                        {metric.peer.toString().replace(/^(\d+\.\d{2}).*$/, "$1")}%
                                    </span>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
                <div className="legend-section">
                    <div className="legend-row">
                        <div className="legend-item">
                            <span
                                className="legend-color"
                                style={{ backgroundColor: "#ff3130" }}
                            ></span>
                            <span className="legend-label">&lt; 51 PCTL</span>
                        </div>
                        <div className="legend-item">
                            <span
                                className="legend-color"
                                style={{ backgroundColor: "#37b6ff" }}
                            ></span>
                            <span className="legend-label">51-70 PCTL</span>
                        </div>
                        <div className="legend-item">
                            <span
                                className="legend-color"
                                style={{ backgroundColor: "#008424" }}
                            ></span>
                            <span className="legend-label">&gt; 70 PCTL</span>
                        </div>
                    </div>
                    <div className="legend-row">
                        <div className="legend-item">
                            <span
                                className="legend-color"
                                style={{
                                    background: "linear-gradient(to bottom, #5adbe4, #0451b0)",
                                }}
                            ></span>
                            <span className="legend-label">{bankName}</span>
                        </div>
                        <div className="legend-item">
                            <span
                                className="legend-color"
                                style={{
                                    background: "#ebeaea",
                                }}
                            ></span>
                            <span className="legend-label">Peer</span>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};